import { createI18n } from 'vue-i18n'
import en from './en.js'
import lv from './lv.js'
import lt from './lt.js'
import et from './et.js'

const savedLocale = localStorage.getItem('locale') || 'lv'

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: { en, lv, lt, et }
})

export default i18n
